import "./Procesos.css";

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CountUp from "react-countup";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaArrowAltCircleRight } from "react-icons/fa";
import logo from "../../../static/logo.png";
import { getApiUrl } from "../../../utils/apiUrl";
import PersonAvatar from "../../0. Utilidades/PersonAvatar";

function Stats() {
  const [statistics, setStatistics] = useState(null);

  useEffect(() => {
    fetch(getApiUrl("api/seleccion/resumen_proceso/"), {
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setStatistics(Array.isArray(data) ? data : []);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
        setStatistics([]);
      });
  }, []);

  if (!statistics || statistics.length === 0) {
    return null;
  }

  return (
    <div id="procesos">
      <h3>Procesos Activos</h3>
      {statistics.map((stat, index) => (
            <div className="procesos-square" key={index}>
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-${index}`}>
                    {stat.coordinador_nombre}
                  </Tooltip>
                }
              >
                <PersonAvatar
                  src={stat.coordinador_imagen}
                  name={stat.coordinador_nombre}
                  alt={`Fotografía de ${stat.coordinador_nombre || "la coordinadora"}`}
                  className="process-person-avatar"
                  tone="profesional"
                />
              </OverlayTrigger>
              <p>
                {stat.curso_nombre} ({stat.curso_comuna})
              </p>

              <div className="procesos-counters">
                {stat.counts.map((count, countIndex) => (
                  <React.Fragment key={countIndex}>
                    <Link
                      to={count.url}
                      className={`procesos-content ${
                        ["Postulantes Aprobadas"].includes(count.label)
                          ? "highlight-aprobadas"
                          : ""
                      } ${
                        ["Postulantes Rechazadas"].includes(count.label)
                          ? "highlight-rechazadas"
                          : ""
                      }`}
                    >
                      <CountUp
                        end={count.value}
                        duration={1.5}
                        className="procesos-intra"
                      />
                      <h1 className="procesos-title">{count.label}</h1>
                      {count.label === "Maestras Postulando" && (
                        <img src={logo} alt={count.label} />
                      )}
                    </Link>
                    {countIndex < stat.counts.length - 2 && (
                      <FaArrowAltCircleRight className="RightArrow" />
                    )}
                  </React.Fragment>
                ))}
                <a
                  className="procesos-content btn btn-outline-primary"
                  href={stat.url}
                  rel="noreferrer"
                  target="_blank"
                >
                  <span className="procesos-intra">LINK</span>
                  <h1 className="procesos-title">Inscripción</h1>
                </a>
              </div>
            </div>
          ))}
    </div>
  );
}

export default Stats;
